<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="入库管理名称">
          <el-input placeholder="请输入入库管理名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <Supply :form="form"></Supply>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加入库</el-button>

      <el-button size="small" icon="el-icon" type="primary" @click="plClick">批量入库</el-button>
    </div>

    <div style="font-weight: bold;">未入库之前，可编辑</div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="inboundOrderNumber" label="入库单号"></el-table-column>
            <!-- <el-table-column prop="supply.name" label="从哪入库"></el-table-column> -->
            <el-table-column prop="tsupply.name" label="入库到哪"></el-table-column>
            <el-table-column prop="totalAmount" label="单据金额(元)"></el-table-column>
            <el-table-column prop="actualAmount" label="实付金额(元)"></el-table-column>
            <el-table-column prop="zf" label="杂费(元)"></el-table-column>
            <el-table-column prop="total" label="实付总金额(元)"></el-table-column>
            <el-table-column prop="inboundQuantity" label="入库数量"></el-table-column>
            <el-table-column prop="varietiesCount" label="品种数"></el-table-column>
            <el-table-column prop="type_text" label="类型"></el-table-column>
            <el-table-column prop="shop_user_text" label="发单人"></el-table-column>
            <el-table-column prop="status_text" label="入库状态"></el-table-column>
            <el-table-column prop="rkd_img" label="入库快递单">
                <template #default="{row}">
                    <el-image 
                    v-if="row.rkd_img"
                    :src="row.rkd_img" 
                    style="width: 50px; height: 50px"
                    :preview-src-list="[row.rkd_img]"
                    ></el-image>
                    <span v-else>无图片</span>
                </template>
                </el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <!-- <el-button @click="prClick(scope.row)"
                 
                 type="text" size="small" v-if="scope.row.status == 1">打印入库单</el-button>
                -->
                <el-button @click="rkClick(scope.row)" v-if="scope.row.status == 0" type="text" size="small">是否入库</el-button>
                <el-button v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="detailtClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
            :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :warehouse_management_id="warehouse_management_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_add="open_detail" :warehouse_management_id="warehouse_management_id"  v-if="open_detail"  
     @close="closeEdit"></Detail>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

      <!-- 上传导入组件  -->
      <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  
  </div>
</template>

<script>
  import Warehouse_managementApi from '@/api/warehouse_management.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';
  import Supply from '@/components/supply/supply_commons.vue';
  import Upload from '@/components/file/import';
  export default {
    components: {
      Upload,
      Add,
      Edit,
      Detail,
      Supply
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {
          supply:{},
          tsupply:{},
        },
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        warehouse_management_id:"",
        dialogVisible:false,
        open_detail:false,


        open_upload:false,
        // 导入类型
        import_type:'warehouse_management',
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      prClick(item){
        this.$router.push({
            path: '/plus/warehouse_management/index/print',
            query: {
              id: item.warehouse_management_id
            }
        });
      },
      plClick(){
        this.open_upload = true
      },
        /*关闭弹窗*/
        closeDialogFunc(e, f) {
        if (f == 'upload') {
          this.open_upload = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//入库管理标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.open_detail = false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.supply_id = self.form.supply_id
        Params.t_supply_id = self.form.t_supply_id
        self.loading = true;
        Warehouse_managementApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.warehouse_management_id = row.warehouse_management_id;
        this.open_edit = true
      },
      detailtClick(row){
        this.warehouse_management_id = row.warehouse_management_id;
        this.open_detail = true
      },
      rkClick(row) {
        let self = this;
        self
          .$confirm('入库之后不再支持编辑，入库后会影响现有库存的sku单价，是否入库?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Warehouse_managementApi.rk(
              {
                warehouse_management_id: row.warehouse_management_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '入库成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Warehouse_managementApi.del(
              {
                warehouse_management_id: row.warehouse_management_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/warehouse_management/index/index.vue